import { BaseModel } from "sjs-base-model";
import InfluencersCampaignDataHitsModel from "./InfluencersCampaignDataHitsModel";
import InfluencersCampaignsShardsModel from "./InfluencersCampaignsShardsModel";

// InfluencersCampaignModel
export default class InfluencersCampaignModel extends BaseModel {
    // response getting from the api mentioned end point
    _shards = { _shards: InfluencersCampaignsShardsModel };
    current_page_no = 0;
    hits = { hits: InfluencersCampaignDataHitsModel };
    total_page_no = 0;
    timed_out = false;
    took = 0;
    constructor(data1) {
        super();

        this.update(data1);
    }
}
